var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{staticClass:"custom_theme",attrs:{"id":"inspire"}},[_c('v-main',{staticClass:"pt-2 pt-sm-2 pt-xs-2 pt-md-0 pt-lg-0 pt-xl-0"},[_c('router-view'),_c('vue-snotify'),_c('Resource')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }